export var AUTH_TYPES = {
  BisIdToken: 'BisToken',
  IdpIdToken: 'IdpIdToken',
  Captcha: 'Captcha'
};
export var EOS = /*#__PURE__*/function (EOS) {
  EOS["android"] = "android";
  EOS["ios"] = "ios";
  return EOS;
}({});
export var EXPlatform = /*#__PURE__*/function (EXPlatform) {
  EXPlatform["android"] = "Webview2";
  EXPlatform["ios"] = "Webview1";
  return EXPlatform;
}({});